"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../../../../../hooks");
var _Component = require("./Component");
var _excluded = ["step", "setStep", "enableTotpLoading", "enableTotp"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Container = function Container(_ref) {
  var isOpen = _ref.isOpen,
    toggle = _ref.toggle;
  var _useEnableTotpWithWiz = (0, _hooks.useEnableTotpWithWizard)(),
    step = _useEnableTotpWithWiz.step,
    setStep = _useEnableTotpWithWiz.setStep,
    enableTotpLoading = _useEnableTotpWithWiz.enableTotpLoading,
    enableTotp = _useEnableTotpWithWiz.enableTotp,
    totp = _objectWithoutProperties(_useEnableTotpWithWiz, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Component.Component, _extends({
    step: step,
    setStep: setStep,
    isOpen: isOpen,
    toggle: toggle,
    onSubmit: enableTotp,
    submitLoading: enableTotpLoading
  }, totp));
};
exports.Container = Container;